(function () {
  'use strict';

  function add(root, id, qty, opts) {
    var buttons = opts.buttons || [];
    if (opts.errorEl) opts.errorEl.hidden = true;
    buttons.forEach(function (b) { if (b) b.disabled = true; });
    var stay = root.dataset.afterAdd !== 'cart';
    return fetch(root.dataset.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Impossible d ajouter ce produit.');
          return j;
        });
      })
      .then(function () {
        if (!stay) { window.location.href = root.dataset.cartUrl; return; }
        buttons.forEach(function (b) { if (b) b.textContent = opts.addedLabel || 'Ajouté'; });
        setTimeout(opts.onDone, 1500);
      }, function (err) {
        if (opts.errorEl) { opts.errorEl.textContent = err.message; opts.errorEl.hidden = false; }
        opts.onDone();
      });
  }

  function initGallery(root) {
    var g = root.querySelector('[data-gallery]');
    if (!g) return;
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
    var counter = g.querySelector('[data-counter]');
    var stage = g.querySelector('.vl-gallery__stage');
    var i = 0;
    function show(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    var prev = g.querySelector('[data-prev]');
    var next = g.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var x = null;
    stage.addEventListener('touchstart', function (e) { x = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x === null) return;
      var dx = e.changedTouches[0].clientX - x;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      x = null;
    });
    root._vlShowMedia = function (id) {
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].dataset.mediaId === String(id)) { show(k); return; }
      }
    };
    show(0);
  }

  function initVariants(root) {
    var form = root.querySelector('.vl-form');
    var dataEl = root.querySelector('[data-variants]');
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var btn = form.querySelector('[data-cta]');
    var stickyBtn = root.querySelector('[data-sticky-cta]');
    var errorEl = root.querySelector('[data-error]');
    var groups = root.querySelectorAll('[data-option]');
    var priceEls = root.querySelectorAll('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var fmt = new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: root.dataset.currency || 'EUR' });

    function money(c) { return fmt.format(c / 100); }
    function optionsOf(v) {
      return v.options || [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
    }
    function current() {
      if (!groups.length) return variants[0];
      var sel = Array.prototype.map.call(groups, function (gr) {
        var c = gr.querySelector('input:checked');
        return c ? c.value : null;
      });
      return variants.filter(function (v) {
        var o = optionsOf(v);
        return o.length === sel.length && o.every(function (val, k) { return val === sel[k]; });
      })[0];
    }
    function setButtons(label, disabled) {
      [btn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = disabled;
        b.textContent = label;
      });
    }
    function render(updateUrl) {
      var v = current();
      if (!v) { idInput.value = ''; setButtons(btn.dataset.labelUnavailable, true); return; }
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      if (compareEl) {
        var has = v.compare_at_price && v.compare_at_price > v.price;
        compareEl.hidden = !has;
        if (has) compareEl.textContent = money(v.compare_at_price);
      }
      setButtons(v.available ? btn.dataset.labelAdd : btn.dataset.labelSold, !v.available);
      if (updateUrl) {
        if (v.featured_media && root._vlShowMedia) root._vlShowMedia(v.featured_media.id);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) { /* ignore */ }
      }
    }
    groups.forEach(function (gr) { gr.addEventListener('change', function () { render(true); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || !idInput.value) return;
      add(root, idInput.value, 1, {
        buttons: [btn, stickyBtn],
        errorEl: errorEl,
        addedLabel: btn.dataset.labelAdded,
        onDone: function () { render(false); }
      });
    });
    render(false);
  }

  function initCrossSell(root) {
    var b = root.querySelector('[data-xsell-add]');
    if (!b) return;
    var label = b.textContent;
    b.addEventListener('click', function () {
      add(root, b.dataset.variantId, 1, {
        buttons: [b],
        errorEl: root.querySelector('[data-error]'),
        addedLabel: 'Ajouté',
        onDone: function () { b.disabled = false; b.textContent = label; }
      });
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-sticky]');
    var cta = root.querySelector('[data-cta]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(cta);
    var sb = bar.querySelector('[data-sticky-cta]');
    if (sb) sb.addEventListener('click', function () { cta.click(); });
  }

  function init(root) {
    if (!root || root.dataset.vlReady) return;
    root.dataset.vlReady = '1';
    initGallery(root);
    initVariants(root);
    initCrossSell(root);
    initSticky(root);
  }

  function initAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vl-pdp]'), init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();